module.exports = __webpack_public_path__ + "images/polygons-2.png";